import { styled } from '@linaria/react'
import { ListStyled } from 'blocks/List'
import { INDENTS, LABEL_INDENTS } from 'vars/index'
import { MultiColumns } from '../../MultiColumns'
import { MultiColumnsItemStyled } from '../../MultiColumns.styled'

/**
 * The title/labels spacing is read from inherited custom properties, so a parent
 * block such as the details page `banner-description` can opt into its own
 * spacing scale without changing the defaults for the other consumers.
 */
export const MCTitleWithLabelsTemplate = styled(MultiColumns)`
  && ${MultiColumnsItemStyled} {
    row-gap: var(--mcTitleWithLabelsRowGap, var(${INDENTS.INDENT_20}));
  }

  && ${ListStyled} {
    flex-wrap: var(--mcLabelsGroupWrap, nowrap);
    column-gap: var(--mcLabelsGroupGap, var(${LABEL_INDENTS.INDENT_10}));
    row-gap: var(--mcLabelsGroupGap, var(${INDENTS.INDENT_20}));
    letter-spacing: var(--mcLabelsGroupLetterSpacing, normal);
  }
`
